'use client';

import { ListBox as HeroListBox, Label, Description } from '@heroui/react';
import { ReactNode } from 'react';

export interface ListBoxProps<T> {
  children: (item: T) => ReactNode;
  items: T[];
  onAction?: (key: string | number) => void;
  selectionMode?: 'none' | 'single' | 'multiple';
}

const ListBoxRoot = <T extends object>({ 
  children, 
  items, 
  onAction,
  selectionMode = 'none' 
}: ListBoxProps<T>) => {
  return (
    <HeroListBox items={items} onAction={onAction} selectionMode={selectionMode}>
      {children}
    </HeroListBox>
  );
};

const Item = ({
  id,
  textValue,
  children,
  description,
}: {
  id: string | number;
  textValue?: string;
  children: ReactNode;
  description?: string;
}) => (
  <HeroListBox.Item id={id} textValue={textValue}>
    <div className="flex flex-col">
      <Label>{children}</Label>
      {description && <Description>{description}</Description>}
    </div>
    <HeroListBox.ItemIndicator />
  </HeroListBox.Item>
);

export const ListBox = Object.assign(ListBoxRoot, {
  Item,
});
